import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={81}
    height={90.37}
    viewBox="0 0 81 90.37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M73.1589 9.01775H65.7188V6.8742C65.7188 3.3528 62.4283 0.5 58.3725 0.5C54.3167 0.5 51.0262 3.35506 51.0262 6.8742V9.01775H29.9868V6.8742C29.9868 3.3528 26.6963 0.5 22.6405 0.5C18.5821 0.5 15.2942 3.35506 15.2942 6.8742V9.01775H7.85414C3.7957 9.01775 0.507812 11.8728 0.507812 15.3919V84.4962C0.507812 88.0176 3.7983 90.8704 7.85414 90.8704H73.1615C77.2199 90.8704 80.5078 88.0153 80.5078 84.4962V15.3919C80.5078 11.8706 77.2173 9.01775 73.1589 9.01775Z"
      fill="url(#paint0_linear_12193_14529)"
    />
    <path
      d="M37.8488 25.2522H37.0425C36.6729 25.2522 36.3707 25.5545 36.3707 25.924V26.7974H34.6574C33.6496 26.7974 32.8435 27.6037 32.8435 28.6113V38.5215C32.8435 39.5293 33.6498 40.3354 34.6574 40.3354H46.3145C47.3223 40.3354 48.1284 39.5291 48.1284 38.5215V28.6113C48.1284 27.6034 47.3221 26.7974 46.3145 26.7974H44.6012V25.924C44.6012 25.5545 44.2989 25.2522 43.9294 25.2522H43.1231C42.7536 25.2522 42.4513 25.5545 42.4513 25.924V26.7974L38.5207 26.7971V25.9238C38.5207 25.5542 38.2184 25.252 37.8488 25.252L37.8488 25.2522ZM46.8519 30.795V38.5216C46.8519 38.8239 46.6166 39.0591 46.3143 39.0591H34.6573C34.355 39.0591 34.1198 38.8239 34.1198 38.5216V30.795H46.8519Z"
      fill="white"
    />
    <path
      d="M43.4585 34.3888H45.2052C45.4405 34.3888 45.642 34.1873 45.642 33.952V32.6419C45.642 32.4066 45.4405 32.2051 45.2052 32.2051H43.4583C43.223 32.2051 43.0215 32.4066 43.0215 32.6419V33.952C43.0552 34.1871 43.2232 34.3888 43.4585 34.3888Z"
      fill="white"
    />
    <path
      d="M39.6314 34.3888H41.3783C41.6136 34.3888 41.8151 34.1873 41.8151 33.952V32.6419C41.8151 32.4066 41.6136 32.2051 41.3783 32.2051H39.6314C39.3961 32.2051 39.1946 32.4066 39.1946 32.6419V33.952C39.1946 34.1871 39.3961 34.3888 39.6314 34.3888Z"
      fill="white"
    />
    <path
      d="M35.7657 34.3888H37.4791C37.7144 34.3888 37.9159 34.1873 37.9159 33.952V32.6419C37.9159 32.4066 37.7144 32.2051 37.4791 32.2051H35.7322C35.4969 32.2051 35.2954 32.4066 35.2954 32.6419V33.952C35.3292 34.1871 35.5307 34.3888 35.7657 34.3888H35.7657Z"
      fill="white"
    />
    <path
      d="M43.4585 37.8478H45.2052C45.4405 37.8478 45.642 37.6463 45.642 37.411V36.1009C45.642 35.8656 45.4405 35.6641 45.2052 35.6641H43.4583C43.223 35.6641 43.0215 35.8656 43.0215 36.1009V37.411C43.0552 37.646 43.2232 37.8478 43.4585 37.8478Z"
      fill="white"
    />
    <path
      d="M39.6314 37.8478H41.3783C41.6136 37.8478 41.8151 37.6463 41.8151 37.411V36.1009C41.8151 35.8656 41.6136 35.6641 41.3783 35.6641H39.6314C39.3961 35.6641 39.1946 35.8656 39.1946 36.1009V37.411C39.1946 37.646 39.3961 37.8478 39.6314 37.8478Z"
      fill="white"
    />
    <path
      d="M35.7657 37.8478H37.4791C37.7144 37.8478 37.9159 37.6463 37.9159 37.411V36.1009C37.9159 35.8656 37.7144 35.6641 37.4791 35.6641H35.7322C35.4969 35.6641 35.2954 35.8656 35.2954 36.1009V37.411C35.3292 37.646 35.5307 37.8478 35.7657 37.8478H35.7657Z"
      fill="white"
    />
    <path
      d="M40.9412 18.398V16.8528C40.9412 16.2144 40.2694 15.8449 39.7318 16.1472L35.4991 18.6667C34.9615 18.969 34.9615 19.7418 35.4991 20.0441L39.7318 22.5972C40.2694 22.9332 40.9412 22.5299 40.9412 21.8916V20.4134C47.7943 20.6487 53.2701 26.2588 53.2701 33.1454C53.2701 40.2001 47.5254 45.911 40.5045 45.911C33.4498 45.911 27.7389 40.1664 27.7389 33.1454C27.7389 28.9797 29.7881 25.0829 33.181 22.6978C33.6513 22.3617 33.752 21.7571 33.4162 21.2868C33.0802 20.8165 32.4756 20.7158 32.0053 21.0516C28.0748 23.8064 25.6897 28.3414 25.6897 33.1453C25.6897 41.3086 32.3412 47.9601 40.5045 47.9601C48.6678 47.9601 55.3193 41.3086 55.3193 33.1453C55.3193 25.15 48.9029 18.6328 40.9412 18.3977L40.9412 18.398Z"
      fill="white"
    />

    <defs>
      <linearGradient
        id="paint0_linear_12193_14529"
        x1={0.507813}
        y1={90.8706}
        x2={87}
        y2={90.8706}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.244792} stopColor="#6DBC5C" />
        <stop offset={1} stopColor="#4F9B3F" />
      </linearGradient>
    </defs>
  </svg>
);
export default SVGComponent;
